const routes = [
    {
        name: 'dashboard',
        url: '/dashboard',
        localized:true
    },
    {
        name: 'vta-val-inv',
        url: '/reportes/auditoria/consumo-inventario-drot',
        localized:true
    },
    {
        name:'dn-ssn-dp',
        url:'/reportes/auditoria/distribucion-numerica-ponderada-sin-stock',
        localized:true
    },
    {
        name:'prices',
        url:'/reportes/auditoria/precio-moda-promedio',
        localized:true
    },
    {
        name: 'vta-val-inv-internal',
        url: '/reportes-interno/auditoria/consumo-inventario-drot',
        localized:true
    },
    {
        name:'dn-ssn-dp-internal',
        url:'/reportes-interno/auditoria/distribucion-numerica-ponderada-sin-stock',
        localized:true
    },
    {
        name:'prices-internal',
        url:'/reportes-interno/auditoria/precio-moda-promedio',
        localized:true
    },
    {
        name: 'generate-data',
        url: '/reportes-interno/auditoria/generar-data',
        localized: true
    },
    {
        name: 'vta-res-val-inv',
        url: '/reportes/auditoria/consumo-resumen-inventario-drot',
        localized: true
    },
    {
        name: 'vta-res-val-inv-internal',
        url: '/reportes-interno/auditoria/consumo-resumen-inventario-drot',
        localized: true
    },
    {
        name:'customer',
        url:'/administracion/customer',
        localized:true
    },
    //CHEQUEOS
    {
        name:'distribution',
        url:'/reportes/chequeos/distribucion',
        localized:true
    },
    {
        name:'project-mass',
        url:'/reportes/chequeos/proyecto-mass',
        localized:true
    },
    {
        name:'distribution-weighted',
        url:'/reportes/chequeos/distribucion-ponderada',
        localized:true
    },
    {
        name:'shopping-share',
        url:'/reportes/chequeos/share-de-compras',
        localized:true
    },
    {
        name:'visibility',
        url:'/reportes/chequeos/visibilidad',
        localized:true
    },
    {
        name:'purchase',
        url:'/reportes/chequeos/compra',
        localized:true
    },
    {
        name:'valued-purchase',
        url:'/reportes/chequeos/compra-valorizada',
        localized:true
    },
    {
        name:'price-average-moda',
        url:'/reportes/chequeos/precio-promedio-moda',
        localized:true
    },
    {
        name:'coexistence',
        url:'/reportes/chequeos/convivencia',
        localized:true
    },
    {
        name:'multi-coexistence',
        url:'/reportes/chequeos/multi-convivencia',
        localized:true
    },
    {
        name:'summary-distribution',
        url:'/reportes/chequeos/resumen-distribucion',
        localized:true
    },
    {
        name:'histogram-prices',
        url:'/reportes/chequeos/histograma-precios',
        localized:true
    },
    {
        name:'histogram-prices-register',
        url:'/reportes/chequeos/histograma-precios-registro',
        localized:true
    },
    {
        name:'overlay-marks',
        url:'/reportes/chequeos/sobreposicion-marcas',
        localized:true
    },
    {
        name:'breadth-sku-brands',
        url:'/reportes/chequeos/amplitud-sku-marcas',
        localized:true
    },
    //CHEQUEOS INTERNO
    {
        name:'distribution-internal',
        url:'/reportes-interno/chequeos/distribucion',
        localized:true
    },
    {
        name:'project-mass-internal',
        url:'/reportes-interno/chequeos/proyecto-mass',
        localized:true
    },
    {
        name:'distribution-weighted-internal',
        url:'/reportes-interno/chequeos/distribucion-ponderada',
        localized:true
    },
    {
        name:'shopping-share-internal',
        url:'/reportes-interno/chequeos/share-de-compras',
        localized:true
    },
    {
        name:'visibility-internal',
        url:'/reportes-interno/chequeos/visibilidad',
        localized:true
    },
    {
        name:'purchase-internal',
        url:'/reportes-interno/chequeos/compra',
        localized:true
    },
    {
        name:'valued-purchase-internal',
        url:'/reportes-interno/chequeos/compra-valorizada',
        localized:true
    },
    {
        name:'price-average-moda-internal',
        url:'/reportes-interno/chequeos/precio-promedio-moda',
        localized:true
    },
    {
        name:'coexistence-internal',
        url:'/reportes-interno/chequeos/convivencia',
        localized:true
    },
    {
        name:'multi-coexistence-internal',
        url:'/reportes-interno/chequeos/multi-convivencia',
        localized:true
    },
    {
        name:'summary-distribution-internal',
        url:'/reportes-interno/chequeos/resumen-distribucion',
        localized:true
    },
    {
        name:'histogram-prices-internal',
        url:'/reportes-interno/chequeos/histograma-precios',
        localized:true
    },
    {
        name:'histogram-prices-register-internal',
        url:'/reportes-interno/chequeos/histograma-precios-registro',
        localized:true
    },
    {
        name:'overlay-marks-internal',
        url:'/reportes-interno/chequeos/sobreposicion-marcas',
        localized:true
    },
    {
        name:'breadth-sku-brands-internal',
        url:'/reportes-interno/chequeos/amplitud-sku-marcas',
        localized:true
    },
    {
        name:'breadth-attributes-brands-internal',
        url:'/reportes-interno/chequeos/amplitud-atributos',
        localized:true
    },
    //ENCUESTAS
    {
        name:'request',
        url:'/encuesta/consulta'
    },
    {
        name:'planning',
        url:'/encuesta/planificacion'
    },
    {
        name:'samples',
        url: '/analisis/muestras'
    },
    {
        name:'base',
        url:'/analisis/base'
    },
    {
        name:'purchase-inventory',
        url:'/analisis/compra-inventario'
    }
];

export default routes;